import React, { useState } from 'react';
import { GameDropIcon } from '../../components/icons/PlatformIcons';
import PushNotify from '../../components/PushNotify/PushNotify';
import DonateModal from '../../components/DonateModal/DonateModal';
import styles from './Header.module.css';

function Header() {
  const [donateOpen, setDonateOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <div className={styles.logoRow}>
            <GameDropIcon size={32} className={styles.logoIcon} />
            <span className={styles.logoText}>GameDrop</span>
          </div>
        </div>
        <div className={styles.actions}>
          <button
            className={styles.donateBtn}
            onClick={() => setDonateOpen(true)}
            title="Support GameDrop"
          >
            <HeartIcon />
            <span>Support</span>
          </button>
          <PushNotify />
        </div>
      </div>
      {donateOpen && <DonateModal onClose={() => setDonateOpen(false)} />}
    </header>
  );
}

function HeartIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
    </svg>
  );
}

export { Header };
export default Header;
